import { EmptyComponent } from "../common/EmptyComponent";
import Loadable from "react-loadable";

export const FullScreenPopup = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "container/full-screen-popup" */
      "./FullScreenPopup"
    ),
  loading: EmptyComponent
});
